import { HttpTypes } from '@medusajs/types'
import { useProductPrice } from '@onclicks/sharedmedusa/hooks/useProductPrice'
import { formatPrice } from '@/utilities/formatPrice'

export default function ProductPrice({
  product,
  variant,
}: {
  product: HttpTypes.StoreProduct
  variant?: HttpTypes.StoreProductVariant
}) {
  const { hasPriceData, displayPrice, currency, hasDiscount, originalPrice, discountPercent } =
    useProductPrice({ product, variant })

  if (!hasPriceData) {
    return <div className="block w-32 h-9 bg-gray-100 animate-pulse" />
  }

  return (
    <div className="mt-3 flex items-baseline gap-3">
      <span className="text-3xl font-bold text-pink">
        {displayPrice != null ? formatPrice(displayPrice, currency) : 'Prix non disponible'}
      </span>
      {hasDiscount && (
        <>
          <span className="text-lg text-muted-foreground line-through">
            {formatPrice(originalPrice as number, currency)}
          </span>
          <span className="rounded-full bg-light-pink/50 px-2 py-0.5 text-sm font-semibold text-pink">
            -{discountPercent}%
          </span>
        </>
      )}
    </div>
  )
}
